
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { DollarSign, CreditCard, Gift } from 'lucide-react';
import BaseWidget from './BaseWidget';

interface RevenueSnapshotWidgetProps {
  id: string;
  index: number;
  revenue: number;
  isCollapsed?: boolean;
  onToggleCollapse?: () => void;
}

const RevenueSnapshotWidget = ({ 
  id, 
  index, 
  revenue, 
  isCollapsed, 
  onToggleCollapse 
}: RevenueSnapshotWidgetProps) => {
  return (
    <BaseWidget
      id={id}
      title="💰 Revenue Snapshot"
      index={index}
      isCollapsed={isCollapsed}
      onToggleCollapse={onToggleCollapse}
    >
      <div className="space-y-4">
        <div className="text-center">
          <div className="text-3xl font-bold text-juv-deep-chestnut">
            ${revenue.toLocaleString()}
          </div>
          <p className="text-sm text-gray-600">Today's Total Revenue</p>
        </div>
        
        <div className="flex justify-center space-x-4">
          <Badge variant="outline" className="flex items-center space-x-1">
            <CreditCard className="h-3 w-3" />
            <span>Payments</span>
          </Badge>
          <Badge variant="outline" className="flex items-center space-x-1">
            <Gift className="h-3 w-3" />
            <span>Credits</span>
          </Badge>
          <Badge variant="outline" className="flex items-center space-x-1">
            <DollarSign className="h-3 w-3" />
            <span>Services</span>
          </Badge>
        </div>
      </div>
    </BaseWidget>
  );
};

export default RevenueSnapshotWidget;
